import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import UserManagementActions from "../../../Actions/UserManagementActions";
import UsermanagementConstants from "../../../Constants/UsermanagementConstants";
import usermanagementStore from "../../../Stores/UsermanagementStore";
import { Button } from "@mui/material";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import AddPlant from "../AddPlant";
import AddIcon from "@mui/icons-material/Add";
import commonUtils from "../../../helpers/commonUtils";
import ConfirmationPopUp from "../../MessageBox/ConfirmationPopUp";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../../Context/LanguageContext";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import { useSelectedConfigActionContext } from "../../../Context/GlobalContext";
import plantStore from "../../../Stores/PlantStores";
import PlantConstants from "../../../Constants/PlantConstants";
import PlantActions from "../../../Actions/PlantActions";
import { customizeFilter } from "../../FilterOptions/CustomizeFilter";
import CustomDataGrid from "../../ReusableComponent/DataGrid/CustomizeDataGrid";
import ImportComponent from "../../ReusableComponent/ImportComponent/importComponent";
import ImportAction from "../../../Actions/ImportAction";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
const Plant = (props) => {
  const [orgid, setOrgid] = useState(0);
  const [orgname, setOrgName] = useState("");
  const [plantDetails, setPlantDetails] = useState("");
  const [plantList, setPlantList] = useState([]);
  const [resPlantList, setResPlantList] = useState([]);
  const [callbackData, setCallbackData] = useState(null);
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [eventType, setEventType] = useState(null);
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const updateSelectedConfig = useSelectedConfigActionContext();
  const isWebsiteAdmin = false;
  const columns = [
    { field: "plantID", headerName: localization.plantid, hideable: false },
    {
      field: "actions",
      type: "actions",
      width: 45,
      hideable: false,
      headerName: localization.actions,
      getActions: (params) => [...getAction(params, localization)],
    },
    { field: "bezeichnung", headerName: localization.plantname },

    {
      field: "showKostWithPlantId",
      headerName: localization.showCostWithPlantId,
    },
  ];
  const importIntial = {
    isOpen: false,
    headerTitle: localization.importPlant,
    subHeaderTitle: localization.importPlantTitle,
    handleClose: handleCloseImport,
    handleImport: handleImport,
    handleDownloadTemplate: handleDownloadTemplate,
  };
  const [openImport, setOpenImport] = useState(importIntial);
  const getPlants = (id) => {
    UserManagementActions.getPlantsByUserId();
    setGlobalSpinner(true);
  };

  // ---------------------- Update list show start -------------------
  useEffect(() => {
    function addPlantSuccess() {
      toast.success(localization.plantAddedSuccessfully);
      commonUtils.hideModalPopUp("addPlantModalClose");
      getPlants(sessionStorage.getItem("userid"));
    }

    function addPlantFailure() {
      const res = plantStore.getNewplantAddResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    plantStore.addChangeListener(
      PlantConstants.ADD_NEW_PLANT_SUCCESS,
      addPlantSuccess,
    );

    plantStore.addChangeListener(
      PlantConstants.ADD_NEW_PLANT_FAILURE,
      addPlantFailure,
    );

    return () => {
      plantStore.removeChangeListener(
        PlantConstants.ADD_NEW_PLANT_SUCCESS,
        addPlantSuccess,
      );

      plantStore.removeChangeListener(
        PlantConstants.ADD_NEW_PLANT_FAILURE,
        addPlantFailure,
      );
    };
  });

  useEffect(() => {
    function updatePlantSuccess() {
      toast.success(localization.plantEditedSuccessfully);
      commonUtils.hideModalPopUp("addPlantModalClose");
      getPlants(sessionStorage.getItem("userid"));
    }

    function UpdatePlantFailure() {
      const res = plantStore.getUpdatePlantResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    plantStore.addChangeListener(
      PlantConstants.UPDATE_PLANT_SUCCESS,
      updatePlantSuccess,
    );

    plantStore.addChangeListener(
      PlantConstants.UPDATE_PLANT_FAILURE,
      UpdatePlantFailure,
    );

    return () => {
      plantStore.removeChangeListener(
        PlantConstants.UPDATE_PLANT_SUCCESS,
        updatePlantSuccess,
      );

      plantStore.removeChangeListener(
        PlantConstants.UPDATE_PLANT_FAILURE,
        UpdatePlantFailure,
      );
    };
  });

  // ---------------------- Update list show end -------------------
  // ---------------------- Delete Plant show start ----------------------
  useEffect(() => {
    function deletePlantSuccess() {
      toast.success(localization.plantDeletedSuccessfully);
      getPlants(sessionStorage.getItem("userid"));
    }

    function deletePlantFailure() {
      const res = plantStore.getDeletePlant();
      toast.error(res);
      setGlobalSpinner(false);
    }

    plantStore.addChangeListener(
      PlantConstants.DELETE_PLANT_SUCCESS,
      deletePlantSuccess,
    );

    plantStore.addChangeListener(
      PlantConstants.DELETE_PLANT_FAILURE,
      deletePlantFailure,
    );

    return () => {
      plantStore.removeChangeListener(
        PlantConstants.DELETE_PLANT_SUCCESS,
        deletePlantSuccess,
      );

      plantStore.removeChangeListener(
        PlantConstants.DELETE_PLANT_FAILURE,
        deletePlantFailure,
      );
    };
  }, []);

  function deletePlantCallback(id) {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(localization.deletePlantConfirmation);
    setCallbackData({
      plantID: id,
    });
    setEventType("DELETE_PLANT");
  }

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "DELETE_PLANT":
          setGlobalSpinner(true);
          PlantActions.deletePlant(data.plantID);
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };
  // ---------------------- Delete Plant show end ----------------------
  useEffect(() => {
    getPlants(sessionStorage.getItem("userid"));
    function getPlantSuccess() {
      const res = usermanagementStore.getPlantResult();

      if (res.length > 0) {
        const tableData = res.map((item) => ({
          id: item.id,
          plantID: item.plantID,
          bezeichnung: item.bezeichnung,
          dateFormat: item.dateFormat,
          language: item.language,
          organisationId: item.organisationId,
          showKostWithPlantId: item.showKostWithPlantId
            ? localization.yes
            : localization.no,
          timeZone: item.timeZone,
        }));
        setResPlantList(tableData);
        setPlantList(tableData);
      } else {
        setResPlantList([]);
        setPlantList([]);
      }
      setGlobalSpinner(false);
      updateSelectedConfig("Plant");
    }

    function getPlantFailure() {
      updateSelectedConfig("Plant");
      setGlobalSpinner(false);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_PLANT_SUCCESS,
      getPlantSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_PLANT_FAILURE,
      getPlantFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_PLANT_SUCCESS,
        getPlantSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_PLANT_FAILURE,
        getPlantFailure,
      );
    };
  }, []);

  // -------------------Add plant button start-----------------------
  const handleAdd = (row) => {
    const name = row.organisationName;
    setOrgid(0);
    setOrgName(name);
    setPlantDetails("");
  };
  function RenderAddPlantButton() {
    return (
      <>
        <Button
          id="addNewPlantTest"
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<AddIcon />}
          data-toggle="modal"
          data-target="#addPlantModal"
        >
          {localization.add}
        </Button>
      </>
    );
  }

  // -----------------------Add plant button end------------------
  // -----------------------Edit plant button start---------------
  const setCurrentPlantDetails = (row) => {
    setPlantDetails(row);
  };

  function RenderEditPlantButton(props) {
    return (
      <>
        <Button
          id="editPlantTest"
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<AiOutlineEdit />}
          data-toggle="modal"
          data-target="#addPlantModal"
        >
          {localization.toolTipEdit}
        </Button>
      </>
    );
  }
  // -----------------------Edit plant button end---------------
  // -----------------------Delete plant button Start---------------
  const Delete = (row) => {
    deletePlantCallback(row.id);
    commonUtils.hideModalPopUp("addPlantModalClose");
  };
  function RenderDeletePlantButton(props) {
    return (
      <>
        <Button
          id="deletePlantTest"
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<AiOutlineDelete />}
        >
          {localization.delete}
        </Button>
      </>
    );
  }
  // -----------------------Delete plant button end---------------
  // Reset

  function handleImportClick() {
    setOpenImport((prev) => ({
      ...prev,
      isOpen: true,
    }));
  }
  function RenderImportButton() {
    return (
      <Button
        id="import"
        className="svgIcon cursorPoint"
        variant="outlined"
        startIcon={<UploadFileOutlinedIcon />}
        onClick={handleImportClick}
      >
        {localization.import}
      </Button>
    );
  }
  function closeEditPlantPopUpCallback() {
    setPlantDetails("");
  }

  const operations = {
    RowOperationList: [
      {
        label: "Edit",
        component: <RenderEditPlantButton />,
        onClick: setCurrentPlantDetails,
      },
      {
        label: "Delete",
        component: <RenderDeletePlantButton />,
        onClick: Delete,
      },
    ],
    GridToolBarAction: [
      { label: "Add", component: <RenderAddPlantButton />, onClick: handleAdd },
      {
        label: "Import",
        component: <RenderImportButton />,
        onClick: handleImportClick,
      },
    ],
    SelectedToolBar: [
      {
        label: "Delete",
        component: <RenderDeletePlantButton />,
        onClick: Delete,
      },
    ],
  };

  function handleImport(seletedFile) {
    setGlobalSpinner(true);
    const obj = {
      ImportType: "Plant",
      ImportFile: seletedFile,
    };
    ImportAction.uploadData(obj);
  }

  function handleCloseImport(_message) {
    if (_message === "success") {
      getPlants(sessionStorage.getItem("userid"));
    }
    setOpenImport((prev) => ({
      ...prev,
      isOpen: false,
    }));
  }

  function handleDownloadTemplate() {
    ImportAction.getTemplate({
      ImportType: "Plant",
      UpdateTempalte: false,
    });
    setGlobalSpinner(true);
  }
  function getAction(params) {
    const _acionList = [];
    _acionList.push(
      <GridActionsCellItem
        label={localization.toolTipEdit}
        showInMenu
        onClick={() => setCurrentPlantDetails(params.row)}
        data-toggle="modal"
        data-target="#addPlantModal"
      />,
    );
    _acionList.push(
      <GridActionsCellItem
        label={localization.delete}
        showInMenu
        onClick={() => Delete(params.row)}
      />,
    );

    return _acionList;
  }
  return (
    <>
      <div className="w-100 h-100" id="content">
        <CustomDataGrid
          Title={localization.orgSetting + " / " + localization.plantpagetitle}
          columns={columns}
          rows={plantList}
          operations={operations}
          onAdd={handleAdd}
          showExport={true}
          showColumns={true}
          showFilters={true}
          showDensity={true}
          visibleColumns={["id", "bezeichnung", "showKostWithPlantId"]}
          showCheckBox={false}
          gridTableHeight={"dataGridLarge"}
        />
      </div>
      {openImport.isOpen && <ImportComponent data={openImport} />}
      <AddPlant
        plantDetails={plantDetails}
        closeEditPlantPopUpCallback={closeEditPlantPopUpCallback}
        isWebsiteAdmin={isWebsiteAdmin}
      />
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
    </>
  );
};

export default Plant;
